import React from 'react';
import { compose } from 'redux';
import styles from '../../../../styles/widgets/my-plan/plan-doughnuts.module.scss';
import { PlanDoughnuts } from '../../../../widgets/components/doughnuts';
import { InputGroup } from '../../../../components/inputs/input-group';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../../components/buttons/button-with-icon';
import { THeadline } from '../../../../components/template';
import { withStaticWidgetLoadingLifecycle } from '../../../../components/layout/content/with-native-loading-state';
import { withWidgetController } from '../../components/with-controller';
import { withWidgetTracking } from '../../hocs/with-widget-tracking';

const Component = React.memo(({ title, subtitle, buttons, labels = {} }) => (
  <>
    <THeadline className={styles.title} title={title} subtitle={subtitle} />
    <div className={styles.doughnuts}>
      <PlanDoughnuts totalHeading={labels.total} monthlyHeading={labels.monthly} />
    </div>
    <InputGroup type='coach'>
      {buttons.map(({ label, link, buttonType }) => (
        <ButtonWithIcon key={label} to={link} type={buttonType}>
          {label}
        </ButtonWithIcon>
      ))}
    </InputGroup>
  </>
));

export const Widget = compose(
  withWidgetController({ className: styles.container }),
  withWidgetTracking,
  withStaticWidgetLoadingLifecycle({ condition: true })
)(Component);
